var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-full dialog-poster"},[_c('div',{staticClass:"dialog-full-wrapper"},[(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e(),_c('img',{attrs:{"src":_vm.img},on:{"click":_vm.onClick}})])])}
var staticRenderFns = []

export { render, staticRenderFns }